import { render, staticRenderFns } from "./PatrioticDetail.vue?vue&type=template&id=00c988d4&scoped=true&"
import script from "./PatrioticDetail.vue?vue&type=script&lang=js&"
export * from "./PatrioticDetail.vue?vue&type=script&lang=js&"
import style0 from "./PatrioticDetail.vue?vue&type=style&index=0&id=00c988d4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00c988d4",
  null
  
)

export default component.exports